import { Outlet, useNavigate } from "react-router-dom";
import Brand from "../../../brand/brand.component";
import BrandFullName from "../../../brand_fullname/brand_fullname.component";
import "./kitchenHome.styles.scss";
import { useContext, useEffect } from "react";
import { AffiliateContext } from "../../../../contexts/affiliate.context";
const KitchenHome = () => {
  const navigate = useNavigate();
  const { affiliate } = useContext(AffiliateContext);
  useEffect(() => {
    if (affiliate === "") {
      navigate("/");
    }
  }, []);
  const handleLogout = () => {
    localStorage.removeItem("affiliate");
    localStorage.removeItem("hotelID");
    localStorage.removeItem("affiliateType");
    window.location.reload();
  };
  return (
    <div className="kitchen-home-container">
      <div className="kitchen-home-top">
        {window.innerWidth > 1024 ? <BrandFullName /> : <Brand />}
        <span className="kitchen-home-title">KITCHEN PAGE</span>
        <span className="logout-button" onClick={handleLogout}>
          Logout
        </span>
      </div>
      <Outlet />
    </div>
  );
};
export default KitchenHome;
